<template>
  <div>
    <v-card>
      <v-toolbar card prominent>
        <v-toolbar-title class="body-2 grey--text">{{$t('subscription.title')}}</v-toolbar-title>
      </v-toolbar>
    </v-card>
    <template>
      <v-card v-if="list">
        <v-card-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            :label="$t('rms.field.search')"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table :headers="table_headers" :items="list" :search="search">
          <!-- Customized header -->
          <template v-slot:headers="props">
            <tr class="light-bg">
              <th
                v-for="header in props.headers"
                :key="header.text"
                :align="header.align"
              >{{ header.text }}</th>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr @click="getSubscription(props.item)" :style="{ cursor: 'pointer'}">
              <td class="text-xs-left font-weight-medium body-2">{{props.item.company.title}}</td>
              <td class="text-xs-left body-2">{{ props.item.company.email }}</td>
              <!-- Subscription status -->
              <td class="text-xs-left font-weight-medium">
                <v-chip
                  color="blue lighten-4 primary--text"
                  small
                  v-if="DEFINES.SUBSCRIPTION.STATUS.TRIALING == props.item.stripe_status && !props.item.ends_at"
                >{{ $t('subscription.trial_ends.title') }}&nbsp;{{getRemainingTime(props.item) }}</v-chip>
                <v-chip
                  color="default grey--text text--darken-2 font-weight-medium"
                  small
                  v-if="DEFINES.SUBSCRIPTION.STATUS.CANCELED != props.item.stripe_status && props.item.ends_at"
                >
                  <v-icon small color="grey darken-2" v-on="on">$vuetify.icons.rms_clock</v-icon>
                  &nbsp;{{ $t('subscription.cancels.title') }}&nbsp;{{getRemainingTime(props.item) }}
                </v-chip>
                <v-chip
                  color="default grey--text text--darken-2 font-weight-medium"
                  small
                  v-if="DEFINES.SUBSCRIPTION.STATUS.CANCELED == props.item.stripe_status"
                >{{ props.item.stripe_status | capitalize }}</v-chip>
                <v-chip
                  color="blue lighten-4 primary--text"
                  small
                  v-if="DEFINES.SUBSCRIPTION.STATUS.ACTIVE == props.item.stripe_status && !props.item.ends_at"
                >{{ props.item.stripe_status | capitalize }}</v-chip>
              </td>
              <td
                class="text-xs-left body-2"
              >{{ moment(props.item.created_at).local().format("D MMM, HH:mm") }}</td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{$t('rms.alert.search_not_found', {
              search: search
              })}}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>
      <v-card v-else>
        <div
          class="text-xs-center subheading pa-5 grey--text darken-1"
        >{{$t('subscription.no_subscription.headline')}}</div>
      </v-card>
    </template>
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import moment from "moment";
import * as MENU from "@/menu";
import * as DEFINES from "@/defines";
import * as HELPER from "@/helper";

export default {
  name: "AdminSubscriptionList",
  data() {
    return {
      moment,
      search: "",
      table_headers: [
        {
          text: i18n.t("rms.table.header.customer"),
          align: "left",
          sortable: false
        },
        {
          text: i18n.t("rms.table.header.email").toUpperCase(),
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: i18n.t("subscription.status.title").toUpperCase(),
          align: "left",
          sortable: false
        },
        {
          text: i18n.t("rms.table.header.created_on").toUpperCase(),
          align: "left",
          sortable: false
        }
      ]
    };
  },
  mounted() {
    this.listSubscriptions();
  },
  computed: {
    ...mapState({
      list(state) {
        return state.adminSubscription.list;
      }
    })
  },
  methods: {
    async listSubscriptions() {
      await this.$store.dispatch("adminSubscription/list");
    },
    getRemainingTime(subscription) {
      // When subscription status is trialing or active
      if (
        !subscription.ends_at &&
        this.DEFINES.SUBSCRIPTION.STATUS.TRIALING == subscription.stripe_status
      )
        return HELPER.getTimeDifference(subscription.trial_ends_at);
      // When subscription is going to be canceled at period end
      if (
        subscription.ends_at &&
        this.DEFINES.SUBSCRIPTION.STATUS.CANCELED != subscription.stripe_status
      ) {
        return HELPER.getTimeDifference(subscription.ends_at);
      }
    },
    async getSubscription(subscription) {
      try {
        var self = this;
        await this.$store
          .dispatch("adminSubscription/get_subscription", {
            subscription_id: subscription.id,
            company_id: subscription.company_id
          })
          .then(() => {
            self.$router.push({
              name: "AdminSubscriptionDashboard",
              params: { subscription_id: subscription.id }
            });
          });
      } catch (error) {
        self.$store.dispatch("app/showMessage", {
          message: error.message,
          color: self.DEFINES.SNACKBAR_ERROR_COLOR
        });
      }
    }
  }
};
</script>

<style  scoped>
.light-bg {
  background: rgba(237, 242, 245, 0.7) !important;
}
</style>
